module.exports = __webpack_public_path__ + "img/optionsmenu-es.4fee947d.png";